module.exports = __webpack_public_path__ + "img/@patas.17c79b2e.png";